import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed by VSM97</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} VSM97</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/VSM97"
                style={{ color: "white" }}
                target="_blank"
                rel="noreferrer"
                title="Visit my GitHub profile"
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://twitter.com/vsmplus7"
                style={{ color: "white" }}
                target="_blank"
                rel="noreferrer"
                title="Visit my X profile"
              >
                <AiOutlineTwitter />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/vsm97/"
                style={{ color: "white" }}
                target="_blank"
                rel="noreferrer"

              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://instagram.com/vsm.97"
                style={{ color: "white" }}
                target="_blank"
                rel="noreferrer"
                title="Visit my LinkedIn profile"
              >
                <AiFillInstagram />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
